export const environment = {
  production: true,
  googlePalcesApiKey: "AIzaSyCxHcsRWuoQlsnlVB0j_3NVY18mwUWPSBc",
  firebaseConfig: {
    apiKey: "AIzaSyDzlEZgM9CwIW2gNt6T9fpiQ-edsB_C06w",
    authDomain: "tripmeld-qa.firebaseapp.com",
    databaseURL: "https://tripmeld-qa-default-rtdb.asia-southeast1.firebasedatabase.app/",
    projectId: "tripmeld-qa",
    storageBucket: "tripmeld-qa.firebasestorage.app",
    messagingSenderId: "364415920769",
    appId: "1:364415920769:web:607108e257490523867b80",
    measurementId: "G-KDFPMQDGVQ"
  },
  integration: 'https://qa.tripmeld.com/api/integration',
  travel: 'https://qa.tripmeld.com/api/travel',
  common: 'https://qa.tripmeld.com/api/common',
  inventory: 'https://qa.tripmeld.com/api/inventory',
  calltracker: "https://qa.tripmeld.com/api/calltracker",
  pdf: 'https://tripmeldcrm-qa-pdf-api.proudwater-2362eaaa.centralindia.azurecontainerapps.io/api/pdf',
  chat: "https://qa.tripmeld.com/api/chat",
  administration: "https://qa.tripmeld.com/api/administration",
  dmc: "https://qa.tripmeld.com/api/dmcs",
  payments: "https://qa.tripmeld.com/api/payments",
  websitebuilder: "https://qa.tripmeld.com/api/websitebuilder",
  public: "https://qa.tripmeld.com/api/public",
  travelintegration: "https://qa.tripmeld.com/api/travelintegrations",
  blobpublic: "https://tmqapublicdata001.blob.core.windows.net"
};
